import GetToken from './GetToken';

const GetAuthHeader = () => {
  return {
    'Content-type': 'application/json',
    'Authorization': GetToken()
  };
}

export default GetAuthHeader;